/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Field_Postal_CodeInputs */

const cs_addr_field_postal_code = /** @type {(inputs: Addr_Field_Postal_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PSČ`)
};

const en_addr_field_postal_code = /** @type {(inputs: Addr_Field_Postal_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZIP`)
};

/**
* | output |
* | --- |
* | "ZIP" |
*
* @param {Addr_Field_Postal_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_field_postal_code = /** @type {((inputs?: Addr_Field_Postal_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Field_Postal_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_field_postal_code(inputs)
	return cs_addr_field_postal_code(inputs)
});